<h1>
  RASTREIO DO PEDIDO:
</h1>
<h3>
  <small>Entregador: {{deliverer}}</small>
</h3>

@if(loaded) {
<mgl-map
  [mapStyle]="'https://tiles.openfreemap.org/styles/liberty'"
  [center]="orderLocation"
  [zoom]="15"
  (mapLoad)="onMapLoad($event)"
>
  <!-- Navigation controls -->
  <mgl-control mglNavigation position="top-right"></mgl-control>

  <!-- Marker at your chosen location -->
  <mgl-marker
    [lngLat]="orderLocation"
    [draggable]="false"
    [anchor]="'bottom'">
    <fa-icon 
      [icon]="faMapMarker" 
      size="3x"
      style="color: #e74c3c; filter: drop-shadow(0 4px 8px rgba(231, 76, 60, 0.4));">
    </fa-icon>
  </mgl-marker>
</mgl-map>
}
